import React from 'react'
import _ from 'lodash'


import { Divider } from '@material-ui/core'
import AssetsDeclaration from './AssetsDeclaration'
import TaxpayerIdentification from './TaxpayerIdentification'
import NoDataFoundMessage from '../NoDataFoundMessage'
import DebtsAndEncumbrances from './DebtsAndEncumbrances'
import SubsectionedIncome from './Income/SubsectionedIncome'
import SingleTableIncome from './Income/SingleTableIncome'
import DependentsInfo from './Income/DependentsInfo'
import IncomeFromIndividual from './IncomeFromIndividual'

const IrValues = ({ irDeclaration, onDeclarationCheck, readOnly, settings, isExportingPDF }) => {
  return (
    <div style={{ width: '100%' }}>
      <div>
        <h2>
          <ul>
            <li>Arquivo de Declaração</li>
          </ul>
        </h2>
      </div>
      <br />
      <div>
        {_.isEmpty(irDeclaration) ? <NoDataFoundMessage message='Arquivo de declaração não enviado' /> : (
          <div className='values-files-container'>
            <TaxpayerIdentification irDeclaration={irDeclaration} />
            <br />
            <DependentsInfo irDeclaration={irDeclaration} isExportingPDF={isExportingPDF} />
            <br />
            <AssetsDeclaration irDeclaration={irDeclaration} onDeclarationCheck={onDeclarationCheck} readOnly={readOnly} settings={settings} isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_holder' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_dependents' isExportingPDF={isExportingPDF} />
            <br />
            <IncomeFromIndividual irDeclaration={irDeclaration} sectionId='income_from_individual_to_holder' isExportingPDF={isExportingPDF} />
            <br />
            <IncomeFromIndividual irDeclaration={irDeclaration} sectionId='income_from_individual_to_dependents' isExportingPDF={isExportingPDF} />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='exempt_income' isExportingPDF={isExportingPDF} />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='exclusive_taxation_income' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_holder_with_suspended_requirements' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_dependents_with_suspended_requirements' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='accumulated_income_from_legal_person_to_holder' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='accumulated_income_from_legal_person_to_dependents' isExportingPDF={isExportingPDF} />
            <br />
            <DebtsAndEncumbrances irDeclaration={irDeclaration} isExportingPDF={isExportingPDF} />
            <br />
            <Divider />
            <br />
            <h2>Atividade Rural</h2>
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='exploited_rural_properties_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_income_and_expenditure_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='calculation_of_rural_results_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='livestock_movement_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_activity_assets_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_activity_debts_in_brazil' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='exploited_rural_properties_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_income_and_expenditure_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='calculation_of_rural_results_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='livestock_movement_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_activity_assets_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='rural_activity_debts_abroad' isExportingPDF={isExportingPDF} />
            <br />
            <Divider />
            <br />
            <h2>Resumo Final</h2>
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='summary_with_taxation_using_legal_deductions' showNothingIfMissing={true} isExportingPDF={isExportingPDF} />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='summary_with_taxation_using_simplified_discount' showNothingIfMissing={true} isExportingPDF={isExportingPDF} />

          </div>
        )}

      </div>
    </div>
  )
}

export default IrValues
